const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
const ACTIONS_TO_SYNC = [CHANGE_LANGUAGE];

export { ACTIONS_TO_SYNC, CHANGE_LANGUAGE };
